<mat-tab-group>
    <mat-tab *ngFor="let producto of productos" [id]="producto.idServicioProducto"
        [label]="producto.Producto.descripcion">
        <app-producto-verificacion [productoServicio]="producto">
        </app-producto-verificacion>
    </mat-tab>
</mat-tab-group>